import InPlayer from '@inplayer-org/inplayer.js';

let pendingRefresh = false;

export const jwt = ({ dispatch, getState }) => next => action => {
    let theStore = getState();
    let token = InPlayer.Account.getToken();

    if (token.expired && !window.location.href.includes('token')) {
        if (!theStore.auth.pendingRefreshingToken && !pendingRefresh) {
            dispatch({ type: 'REFRESHING_TOKEN' });
            pendingRefresh = true;
            // let pos = buffer.map(e => e.type).indexOf('INVALID_TOKEN') - 1;
            // let previousRequest = buffer[pos];
            InPlayer.Account.refreshToken(theStore.paywall.clientId).then(
                resp => {
                    dispatch({ type: 'REFRESHING_TOKEN_SUCCESS' });
                    pendingRefresh = false;
                    const returnValue = next(action);
                    return returnValue;
                }
            );
        }
    } else {
        const returnValue = next(action);
        return returnValue;
    }

    //     if (buffer.length > 20) {
    //         //remove all items but keep the last 20 which forms the buffer
    //         buffer.splice(0, buffer.length - 20);
    //     }
    //     return next(action);
    // }
};



// WEBPACK FOOTER //
// ./src/middleware/jwt.js